import { createIcon } from '@chakra-ui/react'

export const WarningIcon = createIcon({
  displayName: 'WarningIcon',
  viewBox: '0 0 33 33',
  path: (
    <path
      d="M16.5 33C7.45312 33 0 25.5504 0 16.4922C0 7.4496 7.4375 0 16.5 0C25.5469 0 33 7.4496 33 16.4922C33 25.5504 25.5625 33 16.5 33ZM16.5156 18.8348C17.5938 18.8348 18.2188 18.2257 18.2812 17.1013L18.5312 10.3701C18.5938 9.19877 17.7344 8.38665 16.5 8.38665C15.25 8.38665 14.4062 9.18315 14.4688 10.3701L14.7188 17.1169C14.7656 18.2257 15.4062 18.8348 16.5156 18.8348ZM16.5156 24.4728C17.75 24.4728 18.7031 23.6919 18.7031 22.4894C18.7031 21.318 17.7656 20.5215 16.5156 20.5215C15.2656 20.5215 14.2969 21.318 14.2969 22.4894C14.2969 23.6919 15.2656 24.4728 16.5156 24.4728Z"
      fill="currentColor"
    />
  ),
})
